/**
 * Converts size value from "rem" to "px".
 *
 * @param {number} rem
 * @return {number}
 */
function ConvertRemToPixels(rem) {
	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export const BREAKPOINT_SM = ConvertRemToPixels(40);
export const BREAKPOINT_MD = ConvertRemToPixels(48);
export const BREAKPOINT_LG = ConvertRemToPixels(64);
export const BREAKPOINT_XL = ConvertRemToPixels(80);
export const BREAKPOINT_2XL = ConvertRemToPixels(96);
